export enum ConceptItemConstants {
  BELL = 'mni-section:480257799',
}

export function qCode(conceptItem: ConceptItem) {
  return `${conceptItem.scheme}:${conceptItem.code}`;
}

export interface ConceptItem {
  name: string;
  code: string;
  scheme: string;
  type: 'SUBJECT' | 'GENRE';
  attributes: { [key: string]: any };
  relevance?: number;
  icon?: string;
}

export function subject(name: string, code: string, scheme = 'mni-section'): ConceptItem {
  return { name, code, scheme, type: 'SUBJECT', attributes: {} };
}

export function genre(name: string, code: string, scheme = 'mnitype'): ConceptItem {
  return { name, code, scheme, type: 'GENRE', attributes: {} };
}

export interface RequiredInclude {
  title: string;
  item: ConceptItem;
}

export interface FilterGroup {
  title: string;
  items: ConceptItem[];
  visible?: string[];
  requiredInclude?: RequiredInclude;
}
